import classNames from 'classnames'
import { ReactNode } from 'react'
import styles from './NavButtons.module.scss'

interface NavButtonsProps {
  onPrevClick: () => void
  onNextClick: () => void
  prevDisabled?: boolean
  nextDisabled?: boolean
  prevAriaLabel?: string
  nextAriaLabel?: string
}

export function NavButtons({
  onPrevClick,
  onNextClick,
  prevDisabled = false,
  nextDisabled = false,
  prevAriaLabel,
  nextAriaLabel,
}: NavButtonsProps): ReactNode {
  return (
    <div className={styles.Nav}>
      <div className={styles.Nav__button}>
        <button
          onClick={onPrevClick}
          className={styles.Nav__arrow}
          aria-label={prevAriaLabel}
          disabled={prevDisabled}
        />
      </div>
      <div className={styles.Nav__button}>
        <button
          className={classNames(styles.Nav__arrow___right, styles.Nav__arrow)}
          onClick={onNextClick}
          aria-label={nextAriaLabel}
          disabled={nextDisabled}
        />
      </div>
    </div>
  )
}
